import { Dispatch } from "react";
import { format } from "date-fns";
import { AxiosResponse } from "axios";

import {
  showAlert,
  isAPISuccessful,
  checkInternetAndShowAlert,
} from "../../../common/utils";
import {
  setAnnouncementDetails,
  setIsUnreadAnnouncement,
  setAnnouncementListingData,
  setAnnouncementFilterListingData,
  setAnnouncementFilteredListingData,
} from "./slice";
import { RootState } from "../../../redux/store";
import { setLoading } from "../../../redux/global.slice";
import { EndPoint, getApiCall, Module } from "../../../common/constants";

function formatTime(date: Date): string {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour format to 12-hour format
  const formattedHours = (((hours + 11) % 12) + 1).toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${period}`;
}

export const formatAnnouncementDate = (dateString: Date | null) => {
  if (dateString) {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    const now = new Date();
    const secondsDifference = (now.getTime() - date.getTime()) / 1000;

    if (secondsDifference < 10) {
      return "Now";
    } else if (secondsDifference < 60) {
      return `${Math.floor(secondsDifference)} seconds ago`;
    } else if (secondsDifference < 3600) {
      return `${Math.floor(secondsDifference / 60)} minutes ago`;
    } else if (secondsDifference < 86400) {
      return `${formatTime(date)}`;
    } else if (secondsDifference < 172800) {
      return "Yesterday";
    } else {
      return format(date, "MM/dd/yyyy");
    }
  }
};

export const getAnnouncementListing =
  (isFilter?: boolean) =>
  (dispatch: Dispatch<any>, getState: () => RootState) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    const {
      announcementListingQueryParameters: { pageNo, limit },
      announcementFilter: { announcementType, manufacturerId },
    } = getState().announcementSlice;

    const params = `?pageNo=${pageNo}&limit=${limit}${announcementType !== "" ? `&announcementType=${announcementType}` : ""}${manufacturerId !== "" ? `&manufacturerId=${manufacturerId}` : ""}`;

    dispatch(setLoading(true));

    getApiCall(
      Module.consumer + EndPoint.ANNOUNCEMENTS,
      params,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (isAPISuccessful(data.statusCode)) {
          if (isFilter)
            dispatch(setAnnouncementFilteredListingData(data?.data));
          else dispatch(setAnnouncementListingData(data?.data));
        }
        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error?.message);
      },
    );
  };

export const getAnnouncementDetail =
  (announcementId: string) => (dispatch: Dispatch<any>) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    dispatch(setLoading(true));

    getApiCall(
      Module.consumer + `${EndPoint.ANNOUNCEMENTS}/${announcementId}`,
      "",
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (isAPISuccessful(data.statusCode)) {
          dispatch(setAnnouncementDetails(data?.data));
        }
        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error?.message);
      },
    );
  };

export const getUnReadAnnouncement = () => (dispatch: Dispatch<any>) => {
  // Check for network connectivity
  if (!checkInternetAndShowAlert(showAlert)) {
    return;
  }

  dispatch(setLoading(true));

  getApiCall(
    Module.consumer + EndPoint.ANNOUNCEMENT_COUNT,
    "",
    (respData: AxiosResponse<any>) => {
      const { data } = respData;
      if (isAPISuccessful(data.statusCode)) {
        dispatch(setIsUnreadAnnouncement(data?.data?.isUnreadAnnouncement));
      }
      dispatch(setLoading(false));
    },
    (error: any) => {
      dispatch(setLoading(false));
      showAlert(2, error?.message);
    },
  );
};
export const getAnnouncementFilterListing =
  () => (dispatch: Dispatch<any>, getState: () => RootState) => {
    // Check for network connectivity
    if (!checkInternetAndShowAlert(showAlert)) {
      return;
    }

    const {
      announcementFilterListingQueryParameters: { pageNo, limit, searchKey },
    } = getState().announcementSlice;

    const params = `?pageNo=${pageNo}&limit=${limit}${searchKey !== "" ? `&searchKey=${encodeURIComponent(searchKey)}` : ""}`;

    dispatch(setLoading(true));

    getApiCall(
      Module.consumer + EndPoint.ANNOUNCEMENT_FILTER_LIST,
      params,
      (respData: AxiosResponse<any>) => {
        const { data } = respData;
        if (isAPISuccessful(data.statusCode)) {
          dispatch(setAnnouncementFilterListingData(data?.data));
        }
        dispatch(setLoading(false));
      },
      (error: any) => {
        dispatch(setLoading(false));
        showAlert(2, error?.message);
      },
    );
  };
